module.exports = __webpack_public_path__ + "static/media/right_arrow_orange.c94ec1ce.svg";